import start from "../../../scenes/start";
import {TT} from "../../services/i18nService";
import PageBase from "./PageBase";
import { IPagePramsBase } from "./UIPrams";

const {ccclass, property,menu , disallowMultiple} = cc._decorator;

@ccclass
@disallowMultiple
@menu('游戏页面/类名')
export default class o1SelectBox extends PageBase{
    @property(cc.Label)
    lbTitle: cc.Label = null;
    @property(cc.Label)
    lbExplain: cc.Label = null;
    @property(cc.Node)
    ndFirstItem: cc.Node = null;
    @property(cc.Node)
    ndContent: cc.Node = null;

    onLoad() {

    }

    start() {

    }

    private m_dynamicNodes: cc.Node[];

    async OnPageOpen(prams:IPagePramsBase){
        super.OnPageOpen(prams);
        // await this.showSelectBox(prams.title,prams.explain,prams.items,prams.isCancel);
    }

    showSelectBox(title: string, explain: string, items: string[], isCancel: boolean = true): Promise<number> {
        return new Promise<number>(resolve => {
            //
            this.lbTitle.string = title;
            this.lbExplain.string = explain;
            //
            this.m_dynamicNodes = [];
            for (let i = 0; i < items.length; i++) {
                let node: cc.Node = null;
                if (i == 0) {
                    node = this.ndFirstItem;
                } else {
                    node = cc.instantiate(this.ndFirstItem);
                    this.ndContent.addChild(node);
                    this.m_dynamicNodes.push(node);
                }
                node.getChildByName('lb').getComponent(cc.Label).string = items[i];
                node.once('click', () => {
                    this.ClosePage();
                    resolve(i);
                });
            }
            //可取消
            if (isCancel) {
                let cancelNode = cc.instantiate(this.ndFirstItem);
                this.m_dynamicNodes.push(cancelNode);
                this.ndContent.addChild(cancelNode);
                cancelNode.getChildByName('line').active = false;
                let com = cancelNode.getChildByName('lb').getComponent(cc.Label);
                com.enableBold = true;
                com.string = '取消';
                cancelNode.once('click', () => {
                    this.ClosePage();
                })
            }
            //多语言
            TT(this.node);
        })
    }

    // public ClosePage(): void {
    //     super.ClosePage();
    //     this.m_dynamicNodes.forEach(node => {
    //         node.destroy();
    //     })
    //     this.node.destroy();
    // }

    OnPageClose(): void {
        super.OnPageClose();
        this.m_dynamicNodes.forEach(node => {
            node.destroy();
        })
    }

    // update (dt) {}
}